import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Interceptors (for auth/logging)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status !== 401) {
      console.error("API Error:", error);
    }
    return Promise.reject(error);
  }
);

// ------------------ Endpoints ------------------
export const getWorldData = () => api.get("/world-data");
export const getChartsData = (code) => {
  return api.get(`/charts?country_code=${code}`);
};
export const getReports = () => api.get("/drive/files");
export const downloadReport = (fileId) =>
  api.get(`/drive/files/${fileId}/download`, {
    responseType: "blob",
  });
export const downloadChartExcel = (countryCode, indicatorId) =>
  api.get("/charts/export", {
    params: { country_code: countryCode, indicator_id: indicatorId },
    responseType: "blob",
  });


export default api;
